import React from 'react';

import { styled } from '@mui/material/styles';

import { IndianRed, UltramarineBlue } from '@core/theme/baseTheme';
import ErrorFileIcon from '@mui/icons-material/Error';
import UnknownFileIcon from '@mui/icons-material/InsertDriveFile';

export const ErrorIcon = styled(ErrorFileIcon)`
	color: ${IndianRed};
	width: 70px;
  	height: 70px;
`;

export const UnknownIcon = styled(UnknownFileIcon)`
	color: ${UltramarineBlue};
	width: 70px;
  	height: 70px;
`;

export const FileTypeIcon = styled('img')`
	width: 70px !important;
	height: 70px !important;
`;